module.exports = __webpack_public_path__ + "static/media/airbnb.afec9505.webp";